<app-sub-section-header>
    <ng-container buttons>
        <button *ngIf="!editMode" (click)="editMode = true">
            <iota-icon icon="pencil-square" class="text-primary"></iota-icon>
        </button>
        <button *ngIf="editMode" class="btn btn-accent" (click)="onSave(bankDetails)">
            <iota-icon flaticon="floppy-disk" size="1x"> </iota-icon>
        </button>
        <button *ngIf="editMode" class="btn btn-accent" (click)="onCancel()">
            <iota-icon icon="x-mark"></iota-icon>
        </button>
    </ng-container>
</app-sub-section-header>

<div class="w-full mb-10 grid grid-cols-2 justify-between items-start gap-2 gap-x-16">
    <div class="flex flex-row items-center gap-3">
        <span class="min-w-1/4" i18n>Payment method:</span>
        <div class="flex-1">
            <select class="w-full select select-bordered" [disabled]="!editMode" [(ngModel)]="bankDetails.paymentMethod">
                <option *ngFor="let paymentMethod of paymentMethods" [value]="paymentMethod">
                    {{ getPaymentMethodDescription(paymentMethod) }}
                </option>
            </select>
        </div>
    </div>
    <div class="flex flex-row items-center gap-3">
        <span class="min-w-1/4" i18n>Account owner:</span>
        <input type="text" [disabled]="!editMode" class="flex-1 input input-bordered" [(ngModel)]="bankDetails.accountOwner" />
    </div>

    <div class="flex flex-row items-center gap-3">
        <span class="min-w-1/4" i18n>Bank:</span>
        <input type="text" [disabled]="!editMode" class="flex-1 input input-bordered" [(ngModel)]="bankDetails.bankName" />
    </div>
    <div class="flex flex-row items-center gap-3">
        <span class="min-w-1/4" i18n>IBAN:</span>
        <input type="text" [disabled]="!editMode" class="flex-1 input input-bordered" [(ngModel)]="bankDetails.iban" />
    </div>

    <div class="flex flex-row items-center gap-3">
        <span class="min-w-1/4" i18n>BIC:</span>
        <input type="text" [disabled]="!editMode" class="flex-1 input input-bordered" [(ngModel)]="bankDetails.bic" />
    </div>
    <div class="flex flex-row items-center gap-3">
        <span class="min-w-1/4" i18n>Currency:</span>
        <div class="flex-1">
            <select class="w-full select select-bordered" [disabled]="!editMode" [(ngModel)]="bankDetails.currency">
                <option *ngFor="let ccy of currencies" [value]="ccy">{{ ccy }}</option>
            </select>
        </div>
    </div>
</div>
